const LogoPodcasts = ({ width, height, color, waveColor }) => {
  return (
    <svg
      width={width ? width : "144px"}
      viewBox="0 0 144 158"
      height={height ? height : "158px"}
    >
      <rect
        x="27.229"
        y="71.3583"
        width="1.99756"
        height="12.8584"
        fill="#005774"
      />
      <rect
        x="95.1411"
        y="71.3583"
        width="1.99756"
        height="12.8584"
        fill="#005774"
      />
      <rect
        x="117.862"
        y="71.3583"
        width="1.99756"
        height="12.8584"
        fill="#005774"
      />
      <rect
        x="106.501"
        y="66.8641"
        width="1.99756"
        height="21.597"
        fill="#005774"
      />
      <path
        d="M38.5894 66.8641H40.5869V88.4612H38.5894V66.8641Z"
        fill="#005774"
      />
      <path
        d="M83.7808 66.8641H85.7784V88.4612H83.7808V66.8641Z"
        fill="#005774"
      />
      <rect
        x="49.9497"
        y="57.403"
        width="1.99756"
        height="40.9204"
        fill="#005774"
      />
      <rect
        x="72.6704"
        y="57.403"
        width="1.99756"
        height="40.9204"
        fill="#005774"
      />
      <rect
        x="61.3101"
        y="46.2659"
        width="1.99756"
        height="63.4178"
        fill="#005774"
      />
    </svg>
  );
};

export default LogoPodcasts;
